import { breakpoints } from '../config/Global';
//Navigation functions
export default class Nav {
    body;
    headerMenu;
    navButton;
    subParents;
    breakpoint;
    subOuter;
    subInnerHeight;
    constructor(resizeService) {
        this.body = document.querySelector('body');
        this.headerMenu = this.body.querySelector('.js-primary-navigation');
        if (!this.headerMenu)
            return;
        this.navButton = this.headerMenu.querySelector('.js-navigation-button');
        if (this.navButton) {
            this.navButton.addEventListener('click', () => this.hamburgFunc());
        }
        this.subParents = this.headerMenu.querySelectorAll('.js-sub-parent');
        if (!(this.subParents.length > 0))
            return;
        resizeService.watch().subscribe((event) => this.init());
        this.init();
        this.subParents.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                this.subParentEnterFunc(item);
            });
            item.addEventListener('mouseleave', () => {
                this.subParentLeaveFunc(item);
            });
            item.addEventListener('click', (e) => {
                if (this.breakpoint.matches) {
                    const target = e.target;
                    if (!target.classList.contains('nav__link--sub')) {
                        e.preventDefault();
                        this.subParentClickFunc(item);
                    }
                }
            });
        });
    }
    init() {
        this.breakpoint = window.matchMedia(breakpoints.lg);
    }
    hamburgFunc() {
        if (this.body.classList.contains('is--menu-open')) {
            this.body.classList.remove('is--menu-open');
            return;
        }
        this.body.classList.add('is--menu-open');
    }
    subParentEnterFunc(item) {
        if (this.breakpoint.matches)
            return;
        this.subOuter = item.querySelector('.js-sub-outer');
        this.subInnerHeight = item.querySelector('.js-sub-inner').offsetHeight;
        item.classList.add('open');
        Object.assign(this.subOuter.style, {
            height: `${this.subInnerHeight}px`,
        });
    }
    subParentLeaveFunc(item) {
        if (this.breakpoint.matches)
            return;
        this.subOuter = item.querySelector('.js-sub-outer');
        Object.assign(this.subOuter.style, {
            height: `0px`,
        });
        item.classList.remove('open');
    }
    subParentClickFunc(item) {
        this.subOuter = item.querySelector('.js-sub-outer');
        this.subInnerHeight = item.querySelector('.js-sub-inner').offsetHeight;
        if (!item.classList.contains('open')) {
            Object.assign(this.subOuter.style, {
                height: `${this.subInnerHeight}px`,
            });
            item.classList.add('open');
        }
        else {
            Object.assign(this.subOuter.style, {
                height: `0px`,
            });
            item.classList.remove('open');
        }
    }
}
